import './Announcement/AnnouncementUpload.css';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Delete';
import { uploadAdmin } from '../../Actions/createAdmin';

function CreateAdmin() {
  const dispatch = useDispatch();

  const [adminInfo, setAdminInfo] = useState([]);

  // useEffect(() => {
  //   getData();
  // }, []);

  // const getData = async () => {
  //   axios
  //     .get(getUpdates)
  //     .then(response => {
  //       setUdpdateInfo(response.data.data);
  //     })
  //     .catch(error => {
  //       console.log(error);
  //     });
  // };

  // const deleteHandler = async id => {
  //   dispatch(deleteUpdate({ code: id }, userData.token)).then(result => {
  //     getData();
  //   });
  // };

  const validate = Yup.object().shape({
    name: Yup.string().required('Required'),
    department: Yup.string().required('Required'),
    designation: Yup.string().required('Required'),
    phnNumber: Yup.string().required('Required'),
    email: Yup.string().required('Required'),
    empID: Yup.string().required('Required'),
  });

  const userData = JSON.parse(localStorage.getItem('access_token'));

  const formik = useFormik({
    initialValues: {
     name:'',
     department:'',
     designation:'',
     phnNumber:'',
     email:'',
     empID:'',
     role:'ADMIN1',
    },
    validationSchema: validate,
    onSubmit: async (values, onSubmitProps) => {
      dispatch(
        uploadAdmin(
          {
            // code: uuidv4(),
            // title: values.title,
            // description: values.description,
            name:values.name,
            department:values.department,
            designation:values.designation,
            empID:values.empID,
            phnNumber:values.phnNumber,
            email:values.email,
            role:'ADMIN1',
          },
          userData.token,
        ),
      ).then(response => {
        console.log(response);
        // getData();
      });
      onSubmitProps.resetForm();
    },
  });


  return (
    <div className="container">
      <div className="div1">
        <h5 className="h5 head">Enter Details</h5>

        <form className=" d-flex flex-column" onSubmit={formik.handleSubmit}>
          <input
            required
            id="name"
            name="name"
            value={formik.values.name}
            className="announcementinput "
            onChange={formik.handleChange}
            type="text"
            placeholder="Enter Name"
          />
          <input
            required
            id="designation"
            name="designation"
            value={formik.values.designation}
            className="announcementinput "
            onChange={formik.handleChange}
            type="text"
            placeholder="Enter Designation"
          />
          <input
            required
            id="department"
            name="department"
            value={formik.values.department}
            className="announcementinput "
            onChange={formik.handleChange}
            type="text"
            placeholder="Enter Department"
          />
          <input
            required
            id="empID"
            name="empID"
            value={formik.values.empID}
            className="announcementinput "
            onChange={formik.handleChange}
            type="number"
            placeholder="Enter Employee ID"
          />
          <input
            required
            id="email"
            name="email"
            value={formik.values.email}
            className="announcementinput "
            onChange={formik.handleChange}
            type="text"
            placeholder="Enter Email"
          />
          <input
            required
            id="phnNumber"
            name="phnNumber"
            value={formik.values.phnNumber}
            className="announcementinput "
            onChange={formik.handleChange}
            type="number"
            placeholder="Enter Phone Number"
          />

          
        
          <Button
            sx={{
              backgroundColor: '#12c73c',
              border: 'none',
              fontFamily: 'Sora',
              color: 'white',
              width: '350px',
              marginTop: '20px',
              padding: '7px',
              borderRadius: '5px',
              '&:hover': {
                backgroundColor: '#16da44',
                color: 'white',
              },
            }}
            type="submit"
            className="btn1"
          >
            Submit
          </Button>
        </form>
      </div>

      {/* <div className="div2">
        <h5 className="h5">Modify Data</h5>
        <div>
          {announcementInfo.map(data => (
            <div
              style={{
                width: '30%',
                // height: '150px',
                borderRadius: '5px',
                backgroundColor: 'white',
                // boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
                margin: '10px ',
                float: 'left',
                padding: '10px',
              }}
            >
              <div style={{ textAlign: 'end', color: '#FF7345' }}>
                {' '}
                <button onClick={() => deleteHandler(data.code)} style={{ border: 'none', background: 'none' }}>
                  <CloseIcon style={{ color: '#f5363c' }}></CloseIcon>
                </button>
              </div>
              <div
                style={{ color: 'black', fontFamily: 'Sora', margin: '2px 10px', fontWeight: 'bold', fontSize: '18px' }}
              >
                {data.title}
              </div>
              <div style={{ fontFamily: 'Sora', fontSize: '16px', margin: '0 10px' }}>{data.description}</div>
              <div style={{ fontFamily: 'Sora', fontSize: '11px', margin: '0 10px', color: 'grey' }}>{data.date}</div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
}

export default CreateAdmin;
